import { c as _c } from "react/compiler-runtime";
import { Heading } from "@navikt/ds-react";
import { UiSelector } from "@/utils/uiSelectors";
export function HeadingLeder() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Heading size="large" level="1" data-testid={UiSelector.HeadingLeder}>Oppgi nærmeste leder</Heading>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}